module.exports = "/images/2rsstore.png?e465df3c24bfdfeaaad4fd7d14dccf97";